import { useQuery, type UseQueryResult } from 'react-query'

import type { CatalogService } from 'features/catalog/service'
import type { SourcesInfo } from 'features/catalog/types'

/** The underlying real sources feeding one syndicated-source bucket (e.g.
 * every retailer site an "Olaplex" review was syndicated onto), via the
 * same `/project/sources/group/info` endpoint the (private) `sourcepage`
 * feature's `useSourceGroupInfo` calls — not imported directly, since
 * `hooks/` is private to that feature; catalog already owns the same
 * service method. `catalogService` is resolved by the container
 * (`useCatalogService()`) and passed in — only Container.tsx may call a
 * service hook directly. */
export function useSyndicatedSourceInfo(
  catalogService: CatalogService,
  projectId: string,
  sourceName: string,
): UseQueryResult<SourcesInfo> {
  return useQuery(
    ['syndicated_source_group_info', sourceName, projectId],
    () =>
      catalogService.getSourceGroupInfo(
        'syndicated_source_group_info',
        sourceName,
        true,
        projectId,
      ),
    {
      enabled: !!projectId && !!sourceName,
    },
  )
}
